import { useCallback, useMemo, useState } from 'react'

export function useToggle(initial: boolean) {
  const [isActive, setActive] = useState(initial)

  const on = useCallback(() => {
    setActive(true)
  }, [])

  const off = useCallback(() => {
    setActive(false)
  }, [])

  const toggle = useCallback(() => {
    setActive((prev) => !prev)
  }, [])

  const reset = useCallback(() => {
    setActive(initial)
  }, [initial, setActive])

  return useMemo(() => ({ isActive, on, off, toggle, reset }), [isActive, on, off, toggle, reset])
}

export type UseToggle = ReturnType<typeof useToggle>
